import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { listVerticalTrackers } from "@/lib/chiroApi";

export default function VerticalTrackers() {
    const [trackers, setTrackers] = useState(null);

    useEffect(() => {
        listVerticalTrackers().then(setTrackers);
    }, []);

    return (
        <div data-testid="vertical-trackers-page" className="max-w-5xl">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#7cc93c] mb-2">
                // vertical trackers · niche-specific defaults
            </div>
            <h1 className="text-3xl font-bold tracking-tight mb-2">Vertical Trackers</h1>
            <p className="text-[#9ca3af] text-sm mb-6 max-w-2xl">
                Each tracker holds defaults for one business niche: business type, search query, proof
                templates, disqualifiers, and CTA. Campaigns inherit a tracker's defaults, then add
                campaign-level goals on top.
            </p>

            {trackers === null && (
                <div className="font-mono text-[12px] text-[#9ca3af]">Loading…</div>
            )}

            {trackers && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="trackers-grid">
                    {trackers.map((t) => (
                        <Link
                            key={t.id}
                            to={`/vertical-trackers/${t.id}`}
                            data-testid={`tracker-card-${t.slug}`}
                            className={`block p-5 border rounded-[2px] transition-colors ${
                                t.status === "live"
                                    ? "border-[#262a2e] hover:border-[#7cc93c] bg-[#0f1113]"
                                    : "border-[#262a2e]/60 bg-[#0f1113]/60 opacity-80"
                            }`}
                        >
                            <div className="flex items-start justify-between mb-3">
                                <div className="flex items-center gap-2">
                                    <Layers className="w-4 h-4 text-[#7cc93c]" />
                                    <div className="font-bold text-[15px]">{t.name}</div>
                                </div>
                                {t.status === "live" ? (
                                    <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#7cc93c] border border-[#7cc93c]/40 px-2 py-[2px]">
                                        LIVE
                                    </span>
                                ) : (
                                    <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#9ca3af] border border-[#262a2e] px-2 py-[2px]">
                                        COMING LATER
                                    </span>
                                )}
                            </div>
                            <div className="text-[12px] text-[#d1d5db] mb-3 leading-relaxed">
                                {t.summary || "No summary yet."}
                            </div>
                            <div className="font-mono text-[10px] text-[#6b7280] uppercase tracking-[0.15em]">
                                business type · {t.business_type || "—"}
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
